import { View } from "binder"
import { MachineTypeManipulationViewModel, MachineType } from "./MachineTypeManipulationViewModel";
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class MachineTypeManipulationView extends View<MachineTypeManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-0062E2A5-34AA-4509-A29E-7ADAE0D88ED7"
    }
    loadHtml(): string {
        let element = require('./machineTypeManipulation.html').default;
        let style = require('./machineTypeManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machineTypes(v: MachineType) { this._machineTypes = v; } public get machineTypes(): MachineType { return this._machineTypes; } private _machineTypes: MachineType;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
